import {Getters} from "vuex-smart-module";
import MeterState from "@/store/modules/meter/meter-state";

export default class MeterGetters extends Getters<MeterState> {}